// Central registry of real, provided image assets.
// Any asset NOT listed here has not been provided yet and must render as an
// elegant PlaceholderMockup (see components/ui/PlaceholderMockup.tsx) instead
// of a generic stand-in image.

export const FULL_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/nfVwKJ36eYri3rLwJjoeEj/ChatGPT_Image_15_ago_2026__14_44_05__1_-removebg-preview.png';

// Tomo cover / mood images
export const TOMO_IMAGES = {
  tomo1: 'https://cdn.magicpatterns.com/patterns/generated-images/77e1aa01-045c-496e-b726-e7f62ab42f10.jpg',
  tomo2: 'https://cdn.magicpatterns.com/patterns/generated-images/cebcd71a-8237-46ab-a489-8beaeb1d0894.jpg',
  tomo3: 'https://cdn.magicpatterns.com/patterns/generated-images/329a510f-52a8-464b-882c-367131c626d2.jpg',
  tomo4: 'https://cdn.magicpatterns.com/patterns/generated-images/d16655f8-6076-4b5a-a741-605ccd27f6ae.jpg',
  tomo5: 'https://cdn.magicpatterns.com/patterns/generated-images/e11447e0-b356-4823-95eb-96cc1c61e3e5.jpg'
};

// Bono images
export const BONO_IMAGES = {
  bono1: 'https://cdn.magicpatterns.com/patterns/generated-images/71de5942-05d7-4c29-8407-39bb2ef6a2d4.jpg',
  bono2: 'https://cdn.magicpatterns.com/patterns/generated-images/a39fea2f-ca51-4787-a2c4-33513291d5f4.jpg',
  bono3: 'https://cdn.magicpatterns.com/patterns/generated-images/74a4db35-2660-4631-84bf-8364a6fab105.jpg',
  bono4: 'https://cdn.magicpatterns.com/patterns/generated-images/c8426f84-23f9-4fa5-b094-70f2927ed400.jpg',
  bono5: 'https://cdn.magicpatterns.com/patterns/generated-images/295ca0f8-dbd3-4b0d-bb4b-18bd0a01dc42.jpg'
};

// Kit de Ejecución images
export const KIT_IMAGES = {
  mapaDePista: 'https://cdn.magicpatterns.com/patterns/generated-images/98e2afb0-f525-4576-a5b7-cfcfa60257bd.jpg',
  programador12Meses: 'https://cdn.magicpatterns.com/patterns/generated-images/fb7823c0-5062-498c-b05b-b65d62f63fd9.jpg'
};

// "Mira por dentro" carousel / proof section images — real captures from
// inside Maestro en Pista.
export const INSIDE_IMAGES: Record<string, string> = {
  'Ficha 05 — Salida de Pared de Fondo':
    'https://cdn.magicpatterns.com/uploads/1sTjQbao8ExguqYgBdWw2X/WhatsApp_Image_2026-08-16_at_11.42.00_(2).webp',
  'Semáforo de Errores — Base de la Bandeja':
    'https://cdn.magicpatterns.com/uploads/vTTSDraEWLbgW2eZrErpL4/WhatsApp_Image_2026-08-16_at_11.41.59_(2).webp',
  'Ficha 14 — Regla de los 3 Golpes':
    'https://cdn.magicpatterns.com/uploads/5n9hfoVGhwAL3MTTmPw6oN/WhatsApp_Image_2026-08-16_at_11.42.00.webp',
  'La Volea de Definición': 'https://cdn.magicpatterns.com/uploads/j5jcSzpgPoqB4tzQLPjDNL/WhatsApp_Image_2026-08-16_at_11.42.00_(3).webp',
  'Ficha 12 — Remate con Decisión':
    'https://cdn.magicpatterns.com/uploads/tP7Nrfq9oztwxhVuq8J3g6/WhatsApp_Image_2026-08-16_at_11.42.00_(1).webp',
  'Ficha 06 — Pared Lateral y Doble Pared':
    'https://cdn.magicpatterns.com/uploads/7K2pQgpPfGAeUFiBEHFG4t/WhatsApp_Image_2026-08-16_at_11.41.59_(1).webp',
  'Las 8 Zonas Críticas del Pádel':
    'https://cdn.magicpatterns.com/uploads/cNS6NgvqVJ8zjb6v4AeZ1A/WhatsApp_Image_2026-08-16_at_11.41.59.webp'
};
